import { useEffect } from "react";
export default function useKey(key, callback) {
    useEffect(function() {
        if (typeof window !== "undefined") {
            var handler = function(event) {
                if (event.key === key) {
                    callback(event);
                }
            };
            window.addEventListener("keydown", handler);
            return function() {
                return window.removeEventListener("keydown", handler);
            };
        }
        return function() {};
    }, [
        key,
        callback
    ]);
}

//# sourceMappingURL=useKey.js.map